// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useSelector } from "react-redux";

import {
  FilterItem as StyledFilterItem,
  CloseButton,
  UpperCase,
} from "../styles";
import { processColumnNames } from "src/constants/display";
import * as colors from "src/styles/constants/colors";
import Icon from "src/icons";
import { getCanEditReportFilters } from "src/reducers/combinedSelectors";

type Props = {
  value: any,
  column: string,
  handleClose: Function,
};

const Parent = ({ value, column, handleClose }: Props) => {
  const isFilteringAllowed = useSelector((state) =>
    getCanEditReportFilters(state),
  );

  return (
    <StyledFilterItem isFilteringAllowed={isFilteringAllowed}>
      <span>
        {processColumnNames[column]}
        {i18n.t(k._)}
      </span>
      <UpperCase>{value}</UpperCase>
      {isFilteringAllowed && (
        <CloseButton onClick={handleClose}>
          <Icon type="close" color={colors.active} />
        </CloseButton>
      )}
    </StyledFilterItem>
  );
};

export default Parent;
